import { render, staticRenderFns } from "./ShipmentInspectPreview.vue?vue&type=template&id=fa2ce640&scoped=true&"
import script from "./ShipmentInspectPreview.vue?vue&type=script&lang=js&"
export * from "./ShipmentInspectPreview.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentInspectPreview.vue?vue&type=style&index=0&id=fa2ce640&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2ce640",
  null
  
)

export default component.exports